<template>
  <div id="about">
      <br />
      <h2>Channel is a composable media network for creator communities.</h2>
      <p>
        In early 2021, we set out to build a web3 media organization that reimagined the infrastructure of digital media—prioritizing portable, interoperable, and durable communities.
      </p>
      <p>
        In 2022, we realized this goal, working with engineers and creators to release a fully community-funded toolset that enables collective on-chain broadcasting via token-enabled RSS.
      </p>
      <p>
        At the time of development, podcasts were emergent as a beacon for growing extraordinarily generative communities even as their creators, tied to subpar platforms, were struggling to realize the deep value of the relationships to and among their audiences. So we optimized for podcasts first yet built our toolset with  a media-agnostic content distribution core. If it runs on RSS, it can be token-enabled with Channel.
      </p>
      <p>
        Channel launched with the bundled content of its founding creators—Interdependence, Joshua Citarella, and New Models—which can be accessed through our <a href="https://pro.opensea.io/collection/channel-s0">inaugural Tokens</a>.
      </p>
      <p>
        New content from this core group is published via Channel every week. Connect your wallet and listen to exclusive new and archived episodes. For any inquiries join our <a href="https://discord.com/invite/channelxyz">Discord</a> or DM us <a href="https://twitter.com/channel">@channel</a> on Twitter.
      </p>
      <br />
      <hr>
      <br />
      <br />
      <div class="flex">
        <div class="w-half">
          <h3>Team</h3>
        </div>
        <div class="w-half">
          <p>
            <strong>Co-Founder & CEO</strong>
            <br/><a href="https://twitter.com/dnlklr">Daniel Keller</a>
          </p>
          <p>
            <strong>Co-Founder | Product & Tech</strong>
            <br /><a href="https://pointlinesurface.com">Cullen Miller</a>
          </p>
          <p>
            <strong>Founding Creators</strong>
            <br /><a href="https://twitter.com/hollyherndon">Holly Herndon</a> + <a href="https://twitter.com/matdryhurst"><nobr>Mat Dryhurst</nobr></a> (<a href="https://twitter.com/1nterdependence">Interdependence</a>);
            <br /><a href="https://twitter.com/cbcb2000">Caroline Busta</a> + <a href="https://twitter.com/LILINTERNET"><nobr>Lil Internet</nobr></a> (<a href="https://twitter.com/newmodels_io">New Models</a>);
            <br /> <a href="https://twitter.com/joshuacitarella">Joshua Citarella</a> <nobr>(<a href="https://donotresearch.net/">Do Not Research</a>)</nobr>
          </p>
        </div>
      </div>
      <br />
      <hr>
      <br />
      <br />
      <h2>Build your own channel.</h2>
      <p>
        We’ve open-sourced Channel’s code under a ⚖️ MIT license so you can build your own <i>channel</i>. Visit <a href="https://github.com/channeleng/Channel">our GitHub</a> for documentation on how to deploy your own <i>channel</i>.
      </p>
      <p>
        <a href="https://github.com/channeleng/Channel">Channel</a> is a web application framework that:
        <ol class="default">
          <li>1. permits allowlisted admin users to upload media (audio, images, metadata) and format them into episodes.</li>
          <li>2. indexes your media into a stylized front-end web application (e.g. <a href="https://channel.xyz">channel.xyz</a>) for users to preview and listen.</li>
          <li>3. gates your media with a specifiable ERC-721 token; only holders of this token may access the media.</li>
          <li>4. syndicates, serves, and generates unique RSS links per token holder; when ownership of tokens change hands, access is revoked.</li>
        </ol>
      </p>
  </div>
</template>

<script>
export default {
    name: "About"
};
</script>

<style scoped>
  .flex {
    display: flex;
  }

  .w-half {
    width: 50%;
  }

  #about {
    max-width: 800px;
    margin: 3em auto 0 auto;
    padding: 0 5%;
  }
</style>
